module.exports = __webpack_public_path__ + "img/contorno.d2826243.png";